import { render, staticRenderFns } from "./PaidUsers.vue?vue&type=template&id=f7220d1c&"
import script from "@/scripts/users/paidUsers.js?vue&type=script&lang=js&"
export * from "@/scripts/users/paidUsers.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports